export default class RecommendationStatus {
  static open = 0;
  static closed = 1;
  static approved = 2;
  static reject = 3;
}
